import { render, staticRenderFns } from "./FaqManagement.vue?vue&type=template&id=a3917264&scoped=true&"
import script from "./FaqManagement.vue?vue&type=script&lang=js&"
export * from "./FaqManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3917264",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3917264')) {
      api.createRecord('a3917264', component.options)
    } else {
      api.reload('a3917264', component.options)
    }
    module.hot.accept("./FaqManagement.vue?vue&type=template&id=a3917264&scoped=true&", function () {
      api.rerender('a3917264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/FAQ/FaqManagement.vue"
export default component.exports